import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';

import { useResponsive } from '../../../hooks/useResponsive';
import { Iconify } from '../../Iconify';
import './ModalHeader.scss';
/**
 * Props for the ModalHeader component.
 */
export interface ModalHeaderProps {
  children?: JSX.Element | JSX.Element[];
  /**
   * Indicates that Close button will be hidden.
   */
  withoutCloseIcon?: boolean;
  /**
   * Callback triggered when close button is pressed.
   */
  onClose?: () => void;
  className?: string;
}

/**
 * A component that represents the footer of a modal dialog.
 */
export const ModalHeader = ({
  children,
  className,
  onClose,
  withoutCloseIcon,
}: ModalHeaderProps) => {
  const isMobile = useResponsive('down', 'sm');
  return (
    <div
      className={classNames(
        'Mfw-Modal-header',
        {
          'Mfw-Modal-header--mobile': isMobile,
        },
        className,
      )}
    >
      {children}
      {!withoutCloseIcon && (
        <div className="Mfw-Modal-headerIcon__wrapper">
          <IconButton onClick={onClose}>
            <Iconify
              className="Mfw-Modal-headerIcon"
              icon="mdi:close"
              size="large"
            />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default ModalHeader;
